import Modal from 'Common/Components/Modal';
import React from 'react'
import { format } from 'date-fns';

interface EventDetailProps {
  show: boolean;
  onHide?: () => void;
  eventData: any;
}
const EventDetailModal: React.FC<EventDetailProps> = ({ show, onHide, eventData }) => {

  return (
    <>
      {/* Events Modal */}
      <Modal show={show} onHide={onHide} modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600">
        <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
          <Modal.Title className="text-16">Event Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form className="needs-validation" name="event-form" id="form-event">
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">

              {/* Title */}
              <div className="xl:col-span-12 flex gap-1 items-end">
                <label htmlFor="event-title" className="inline-block text-base font-medium w-[100px]">Title</label>
                <input disabled type="text" id="event-title" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Title"
                  name="title"
                  value={eventData?.title}
                />
              </div>

              {/* Description */}
              <div className="xl:col-span-12 flex gap-1 items-end">
                <label htmlFor="event-description" className="inline-block text-base font-medium w-[100px]">Description</label>
                <input disabled type="text" id="event-description" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Description"
                  name="description"
                  value={eventData?.description}
                />
              </div>

              {/* Location */}
              <div className="xl:col-span-12 flex gap-1 items-end">
                <label htmlFor="event-location" className="inline-block text-base font-medium w-[100px]">Location</label>
                <input disabled type="text" id="event-location" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Location"
                  name="location"
                  value={eventData?.location}
                />
              </div>
              {/* Status */}
              <div className="xl:col-span-12 flex gap-1 items-end">
                <label htmlFor="event-status" className="inline-block text-base font-medium w-[100px]">
                  Status
                </label>
                <input disabled type="text" id="event-status" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="status"
                  name="status"
                  value={eventData?.status}
                />
              </div>

              {/* Visibility */}
              <div className="xl:col-span-12 flex gap-1 items-end">
                <label htmlFor="event-visibility" className="inline-block text-base font-medium w-[100px]">
                  Visibility
                </label>
                <input disabled type="text" id="event-visibility" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Visibility"
                  name="visibility"
                  value={eventData?.visibility}
                />
              </div>

              <div className="xl:col-span-12 flex gap-1 items-end">
                <label htmlFor="event-start" className="inline-block text-base font-medium w-[100px]">Start</label>
                <input
                  disabled
                  type="datetime-local"
                  id="event-start"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Start"
                  name="start"
                  value={eventData?.startTime ? `${format(new Date(eventData.startTime), "yyyy-MM-dd'T'HH:mm")}` : ''}
                />
              </div>
              <div className="xl:col-span-12 flex gap-1 items-end">
                <label htmlFor="event-end" className="inline-block text-base font-medium w-[100px]">End</label>
                <input
                  disabled
                  type="datetime-local"
                  id="event-end"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="end"
                  name="end"
                  value={eventData?.endTime ? `${format(new Date(eventData.endTime), "yyyy-MM-dd'T'HH:mm")}` : ''}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default EventDetailModal